import { useCustomSWR } from 'utils/hooks/fetchers'

export const useGuessLikesByArticleClassification = (
  articleClassificationId
) => {
  const genUrl = () =>
    articleClassificationId
      ? `/articleClassifications/${articleClassificationId}/guessLike`
      : null
  return useCustomSWR(genUrl)
}
